/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, {useState} from "react";
import {NavLink} from "react-router-dom";
import {withTranslation} from "react-i18next";

import {Grid, Card, CardContent} from "@material-ui/core";

import ContactMailIcon from "@material-ui/icons/ContactMail";

import {useMutation} from "@apollo/client";

import {useThemeData} from "../../../context/ThemeDataContext";
import {useAuthData} from "../../../context/AuthProvider";

import MiniCartProducts from "./MiniCartComponents/MiniCartProducts";
import GeneralButton from "../../Buttons";

import {
    UPDATE_SHOPPINGCART
} from "../../../queries";

function MiniCart(props) {
    const {logins} = useAuthData();
    const {site_id} = useThemeData().themeData.site;
    const {
        border_radius,
        font_family,
        font_family_button,
        primary_color_2,
        primary_color_4,
        background_color_2,
        background_color_4,
    } = useThemeData().themeData.site.theme;

    const dataCart = props.dataCart;

    const [session_id] = useState(localStorage.getItem("session_id"));
    const setMessages = props.setMessages;

    const onSuccess = () => {
        const location = {
            pathname: "/addressform",
            state: {login_name: logins, site_id: site_id, user_id: props.user_id},
        };
        props.history.push(location);
    };

    const [
        updateShoppingcart,
        {loading: loadingUpdateShoppingCart, error: errorUpdateShoppingCart},
    ] = useMutation(UPDATE_SHOPPINGCART, {
        onCompleted: onSuccess,
    });

    const handleUpdateShoppingcart = (e, data) => {
        e.preventDefault();
        if (!loadingUpdateShoppingCart && !errorUpdateShoppingCart) {
            updateShoppingcart({
                variables: {
                    id: data.shoppingcart.id,
                    session_id: session_id,
                    tax: data.shoppingcart.tax,
                    discount: data.shoppingcart.discount,
                    subtotaal: data.shoppingcart.subtotaal,
                    totaal: data.shoppingcart.totaal,
                    shippingcost_type: data.shoppingcart.shippingcost_type,
                    shippingcost_type_name: data.shoppingcart.shippingcost_type_name,
                },
                optimisticResponse: {
                    __typename: "Mutation",
                    updateShoppingcart: {
                        __typename: "Shoppingcart",
                        id: data.shoppingcart.id,
                        tax: data.shoppingcart.tax,
                        discount: data.shoppingcart.discount,
                        subtotaal: data.shoppingcart.subtotaal,
                        totaal: data.shoppingcart.totaal,
                        shippingcost_type: data.shoppingcart.shippingcost_type,
                        shippingcost_type_name: data.shoppingcart.shippingcost_type_name,
                        session_id: session_id,
                    },
                },
                // fetchPolicy: "no-cache",
            });
        }
    };

    //console.log(dataCart.shoppingcart);

    return (
        <div className="navbar-cart">
            <div
                className={`shoppingCart`}
                style={{
                    fontFamily: `${font_family}`,
                    color: `${primary_color_2}`,
                }}
            >
                {/*{props.navbar && props.site_id !== 178 && (*/}
                {/*    <Grid container direction="row" className="width-fill proceed_checkout_container">*/}
                {/*        <NavLink*/}
                {/*            exact*/}
                {/*            to="/cart"*/}
                {/*            style={{*/}
                {/*                fontFamily: `${font_family_button}`,*/}
                {/*                color: `${primary_color_4}`,*/}
                {/*                backgroundColor: `${background_color_2}`,*/}
                {/*                borderColor: `${background_color_2}`,*/}
                {/*                borderRadius: `${border_radius}`,*/}
                {/*            }}*/}
                {/*            id="linkToCart"*/}
                {/*            className="btn-light btn-margin full-width MuiButtonBase-root MuiButton-root MuiButton-contained btn"*/}
                {/*        >*/}
                {/*            {props.t("shoppingcart:Proceed to checkout")}*/}
                {/*        </NavLink>*/}
                {/*    </Grid>*/}
                {/*)}*/}
                <Grid
                    container
                    direction="row"
                    className={`product_body`}
                >
                    <MiniCartProducts
                        {...props}
                        setMessages={setMessages}
                    />
                </Grid>


                <Card className="col-xl-12 col-lg-12 col-md-12 col-xs-12 ">
                    <CardContent
                        className="row border-bottom-small"
                        style={{
                            borderColor: `${background_color_4}`,
                        }}
                    >

                        <Grid
                            container
                            direction="row"
                            className={`product_body`}
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Grid item lg={8} sm={8} xs={8}
                                  className="col-lg-6 col-md-6 col-xs-12 font-bold text-start"
                                  style={{color: `${primary_color_2}`, paddingTop: 5, paddingBottom: 5}}
                            >
                                {props.t("shoppingcart:Subtotal")}
                            </Grid>
                            <Grid item lg={4} sm={4} xs={4}
                                  style={{color: `${primary_color_2}`, paddingTop: 5, paddingBottom: 5, textAlign: 'right'}}
                                  className="col-lg-6 col-md-6 col-xs-12 text-end"
                            >
                                € {dataCart.shoppingcart.subtotaal}
                            </Grid>
                            <Grid item lg={8} sm={8} xs={8}
                                  className="col-lg-6 col-md-6 col-xs-12 font-bold text-start"
                                  style={{color: `${primary_color_2}`, paddingTop: 5, paddingBottom: 5}}
                            >
                                {props.t("shoppingcart:Total")}
                            </Grid>
                            <Grid item lg={4} sm={4} xs={4}
                                  style={{color: `${primary_color_2}`, paddingTop: 5, paddingBottom: 5, textAlign: 'right'}}
                                  className="col-lg-6 col-md-6 col-xs-12 text-end"
                            >
                                € {dataCart.shoppingcart.totaal}
                            </Grid>
                        </Grid>
                        {props.navbar !== true && (
                            <>
                            <Grid
                                container
                                direction="row"
                                className={`product_body`}
                            >
                                <Grid item lg={8} sm={8} xs={8}
                                    style={{color: `${primary_color_2}`, paddingTop: 5, paddingBottom: 5}}
                                    className="col-lg-6 col-md-6 col-xs-12 font-bold text-start"
                                >
                                    {props.t("shoppingcart:Tax")}
                                </Grid>
                                <Grid item lg={4} sm={4} xs={4}
                                    style={{color: `${primary_color_2}`, paddingTop: 5, paddingBottom: 5, textAlign: 'right'}}
                                    className="col-lg-6 col-md-6 col-xs-12 text-end"
                                >
                                    € {dataCart.shoppingcart.tax}
                                </Grid>
                            </Grid>
                                {dataCart.shoppingcart.administrationcosts !== "0,00" && (
                                    <>
                                        <Grid
                                            container
                                            direction="row"
                                            className={`product_body`}
                                        >
                                            <Grid item lg={8} sm={8} xs={8}
                                            style={{color: `${primary_color_2}`, paddingTop: 5, paddingBottom: 5}}
                                            className="col-lg-6 col-md-6 col-xs-12 font-bold text-start"
                                        >
                                            {props.t("shoppingcart:Administrationcosts")}
                                            </Grid>
                                            <Grid item lg={4} sm={4} xs={4}
                                            style={{color: `${primary_color_2}`, paddingTop: 5, paddingBottom: 5, textAlign: 'right'}}
                                            className="col-lg-6 col-md-6 col-xs-12 text-end"
                                        >
                                            € {dataCart.shoppingcart.administrationcosts}
                                            </Grid>

                                        </Grid>
                                    </>
                                )}

                                {dataCart.shoppingcart.shippingcost !== "0,00" && (
                                    <>
                                        <Grid
                                            container
                                            direction="row"
                                            className={`product_body`}
                                        >
                                        <Grid item lg={8} sm={8} xs={8}
                                            style={{color: `${primary_color_2}`, paddingTop: 5, paddingBottom: 5}}
                                            className="col-lg-6 col-md-6 col-xs-12 font-bold text-start"
                                        >
                                            {props.t("shoppingcart:Shipping and handling")}
                                        </Grid>
                                        <Grid item lg={4} sm={4} xs={4}
                                            style={{color: `${primary_color_2}`, paddingTop: 5, paddingBottom: 5, textAlign: 'right'}}
                                            className="col-lg-6 col-md-6 col-xs-12  text-end"
                                        >
                                            € {dataCart.shoppingcart.shippingcost}
                                        </Grid>

                                        </Grid>
                                    </>
                                )}
                                {dataCart.shoppingcart.discount !== "0,00" && (
                                    <>
                                        <Grid
                                            container
                                            direction="row"
                                            className={`product_body`}
                                        >
                                            <Grid item lg={8} sm={8} xs={8}
                                            style={{color: `${primary_color_2}`, paddingTop: 5, paddingBottom: 5}}
                                            className="col-lg-6 col-md-6 col-xs-12 font-bold text-start"
                                        >
                                            {props.t("shoppingcart:Discount")}
                                            </Grid>
                                        <Grid item lg={4} sm={4} xs={4}
                                            style={{color: `${primary_color_2}`, paddingTop: 5, paddingBottom: 5, textAlign: 'right'}}
                                            className="col-lg-6 col-md-6 col-xs-12 text-end"
                                        >
                                            - € {dataCart.shoppingcart.discount}
                                        </Grid>
                                        </Grid>
                                    </>
                                )}
                            <Grid
                                container
                                direction="row"
                                className={`product_body`}
                            >
                                <Grid item lg={8} sm={8} xs={8}
                                    style={{color: `${primary_color_2}`, paddingTop: 5, paddingBottom: 5}}
                                    className="col-lg-6 col-md-6 col-xs-12 font-bold text-start"
                                >
                                    {props.t("shoppingcart:Total")}
                                </Grid>
                                <Grid item lg={4} sm={4} xs={4}
                                    style={{color: `${primary_color_2}`, paddingTop: 5, paddingBottom: 5, textAlign: 'right'}}
                                    className="col-lg-6 col-md-6 col-xs-12 text-end"
                                >
                                    € {dataCart.shoppingcart.totaal}
                                </Grid>
                            </Grid>
                            </>
                        )}
                        {props.type === "equestrianPhotoService" && (
                            <GeneralButton
                                onClick={(e) => handleUpdateShoppingcart(e, dataCart)}
                                style={{
                                    backgroundColor: "#4AAC17",
                                    marginRight: "0px",
                                    marginTop: "15px"
                                }}
                                className="btn btn-light"
                                type="submit"
                                endIcon={<ContactMailIcon color="inherit"/>}
                            >
                                {props.t("shoppingcart:Proceed to address form")}
                            </GeneralButton>
                        )}
                    </CardContent>
                </Card>
                {props.navbar && (
                    <Grid container direction="row" className="width-fill proceed_checkout_container">
                        <NavLink
                            exact
                            to="/cart"
                            style={{
                                fontFamily: `${font_family_button}`,
                                color: `${primary_color_4}`,
                                backgroundColor: `${background_color_2}`,
                                borderColor: `${background_color_2}`,
                                borderRadius: `${border_radius}`,
                            }}
                            id="linkToCart"
                            className="btn-light btn-margin full-width MuiButtonBase-root MuiButton-root MuiButton-contained btn"
                        >
                            {props.t("shoppingcart:Proceed to checkout")}
                        </NavLink>
                    </Grid>
                )}
            </div>
        </div>
    );
}

export default React.memo(
    withTranslation(["message", "shoppingcart", "shoppage"])(MiniCart)
);
